import { Avatar, Box, Grid, Paper, Stack, Typography } from '@mui/material';
import { green } from '@mui/material/colors';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import SelectFieldTorneosComponent from '../../torneos/components/SelectFieldTorneos';
import { allJuegosAction, deleteJuegosAction } from '../JuegosAction';
import { PARAMS_JUEGOS } from '../JuegosReducer';

const ListadoCardJuegos = ({ idEquipo }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const torneosStore = Redux.useSelector((state) => state.torneos);
  const juegosStore = Redux.useSelector((state) => state.juegos);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    const fetchData = async () => {
      if (idEquipo) return;
      dispatch({
        type: PARAMS_JUEGOS,
        payload: {
          ...juegosStore.params,
          idTorneo: torneosStore.activo.id,
        },
      });
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const fetchData = async () => {
      if (juegosStore.all.length === 0 && torneosStore.all.length === 1) {
        dispatch({
          type: PARAMS_JUEGOS,
          payload: { ...juegosStore.params, idTorneo: torneosStore.all[0].id },
        });
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [torneosStore.all]);

  React.useEffect(() => {
    const fetchData = async () => {
      if (idEquipo) {
        await allJuegosAction(dispatch, {
          idEquipo: idEquipo,
          idTorneo: juegosStore.params.idTorneo,
        });
        return;
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [juegosStore.params]);

  async function _onDeleteHandler() {
    setLoadingDelete(true);
    await deleteJuegosAction(
      { dispatch, notify },
      juegosStore.activo.id,
      juegosStore.params,
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  }

  const card = (juego) => (
    <Stack
      direction="column"
      alignItems="center"
      sx={{
        backgroundColor: juego.ganador ? green[100] : 'white',
        width: '200px',
        py: 1,
      }}
    >
      <Avatar
        alt={juego.equipo.imagen.nombre}
        sx={{ width: 60, height: 60 }}
        src={getFilesArchivos(juego.equipo.imagen)}
      />
      <Box sx={{ height: '50px', display: 'flex', alignItems: 'center' }}>
        <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>
          {juego.equipo.nombre}
        </Typography>
      </Box>
      {juego.equipo.lider ? (
        <Typography variant="caption" sx={{ fontWeight: 'normal' }}>
          {juego.equipo.lider?.jugador.perfil.pnombre}{' '}
          {juego.equipo.lider?.jugador.perfil.papellido}
        </Typography>
      ) : (
        <Typography variant="caption">Sin Líder</Typography>
      )}
      <Typography
        variant="h4"
        sx={{ color: juego.ganador ? 'black' : 'grey', fontWeight: 'bold' }}
      >
        {juego.resultado}
      </Typography>
    </Stack>
  );

  return (
    <Grid container>
      <Grid item md={12} sx={{ p: 2, pb: 0 }}>
        <LoadingWidget isLoading={juegosStore.loadingAll || loadingDelete} />
        <SelectFieldTorneosComponent
          isAll={false}
          value={juegosStore.params.idTorneo}
          onChange={async (idTorneo) => {
            const payload = {
              ...juegosStore.params,
              idTorneo,
            };
            dispatch({ type: PARAMS_JUEGOS, payload });
          }}
        />
      </Grid>
      <Grid item md={12}>
        <Grid container spacing={2} sx={{ p: 2 }}>
          {juegosStore.all.map((el) => {
            return (
              <Grid item md={6} align="center">
                <Paper elevation={4}>
                  <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                    {el.ronda.nombre}
                  </Typography>
                  <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                    {el.fechaHora}
                  </Typography>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-evenly"
                  >
                    {card(el.equipos[0])}
                    <Typography variant="h6" sx={{ fontWeight: 'bold', m: 2 }}>
                      VS
                    </Typography>
                    {card(el.equipos[1])}
                  </Stack>
                </Paper>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
      {juegosStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">{juegosStore.activo.nombre}</Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoCardJuegos;
